/**
 * Lisséa — motion premium
 * Révélation progressive : plus on scroll, plus l’animation apparaît
 */
(function () {
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var failsafeTimer = null;
  var revealTicking = false;

  function revealAll() {
    document.querySelectorAll('.lissea-reveal').forEach(function (el) {
      el.style.setProperty('--lissea-progress', '1');
      el.classList.add('is-inview');
    });
    document.querySelectorAll('.lissea-hero:not(.is-ready)').forEach(function (hero) {
      hero.classList.add('is-ready');
    });
  }

  function initHero() {
    document.querySelectorAll('.lissea-hero:not(.is-ready)').forEach(function (hero) {
      requestAnimationFrame(function () {
        hero.classList.add('is-ready');
      });
    });
  }

  /** Auto-marque les blocs principaux */
  function enhanceSections() {
    var selectors = [
      '.lissea-trust__item',
      '.lissea-split__media',
      '.lissea-split__copy',
      '.lissea-steps__item',
      '.lissea-benefits__card',
      '.lissea-reviews .lissea-home__section-head',
      '.lissea-reviews__slot',
      '.lissea-reviews__cta',
      '.lissea-offer__media',
      '.lissea-offer__copy',
      '.lissea-faq .lissea-home__section-head',
      '.lissea-faq__item',
      '.lissea-pdp-strip .lissea-pdp-guarantees > li',
      '.lissea-home__section-head',
    ];

    /* Pas d’animation sur le footer */
    document.querySelectorAll('.lissea-mini-footer .lissea-reveal').forEach(function (el) {
      el.classList.remove('lissea-reveal', 'lissea-reveal--left', 'lissea-reveal--right', 'lissea-reveal--scale', 'is-inview');
      el.style.removeProperty('--lissea-progress');
      el.style.removeProperty('--lissea-delay');
    });

    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el, index) {
        if (el.closest('.lissea-mini-footer')) return;
        if (el.classList.contains('lissea-reveal')) return;
        el.classList.add('lissea-reveal');
        if (!el.style.getPropertyValue('--lissea-delay')) {
          el.style.setProperty('--lissea-delay', String(Math.min(index, 6) * 40));
        }
      });
    });

    document.querySelectorAll('.lissea-split__media, .lissea-offer__media').forEach(function (el) {
      el.classList.add('lissea-reveal--scale');
    });
    document.querySelectorAll('.lissea-split__copy, .lissea-offer__copy').forEach(function (el) {
      el.classList.add('lissea-reveal--right');
    });
  }

  function clamp(value, min, max) {
    return Math.min(max, Math.max(min, value));
  }

  /**
   * Progress 0 → 1 selon la position dans le viewport.
   * Plus l’élément monte à l’écran en scrollant, plus il apparaît.
   */
  function getElementProgress(el) {
    var rect = el.getBoundingClientRect();
    var viewH = window.innerHeight || document.documentElement.clientHeight || 1;
    var start = viewH * 0.96;
    var end = viewH * 0.28;
    var progress = (start - rect.top) / (start - end);
    return clamp(progress, 0, 1);
  }

  function updateScrollReveals() {
    var items = document.querySelectorAll('.lissea-reveal');
    if (!items.length) {
      revealTicking = false;
      return;
    }

    items.forEach(function (el) {
      if (el.closest('.lissea-mini-footer, .lissea-section-footer')) return;

      var delayMs = parseFloat(el.style.getPropertyValue('--lissea-delay') || '0') || 0;
      /* Léger décalage lié au delay pour un effet cascade au scroll */
      var delayFactor = clamp(delayMs / 400, 0, 0.2);
      var raw = getElementProgress(el);
      var progress = clamp((raw - delayFactor) / (1 - delayFactor || 1), 0, 1);

      el.style.setProperty('--lissea-progress', progress.toFixed(3));

      if (progress >= 0.92) {
        el.classList.add('is-inview');
      } else {
        el.classList.remove('is-inview');
      }
    });

    revealTicking = false;
  }

  function onRevealScroll() {
    if (revealTicking) return;
    revealTicking = true;
    window.requestAnimationFrame(updateScrollReveals);
  }

  function initScrollProgressReveals() {
    if (reduceMotion) {
      revealAll();
      return;
    }

    if (window.__lisseaScrollRevealBound) {
      onRevealScroll();
      return;
    }
    window.__lisseaScrollRevealBound = true;

    window.addEventListener('scroll', onRevealScroll, { passive: true });
    document.addEventListener('scroll', onRevealScroll, { passive: true, capture: true });
    window.addEventListener('resize', onRevealScroll, { passive: true });
    window.addEventListener('orientationchange', onRevealScroll, { passive: true });

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', onRevealScroll, { passive: true });

    onRevealScroll();
  }

  function getScrollY() {
    var doc = document.scrollingElement || document.documentElement;
    var wrapper = document.querySelector('.page-wrapper');
    var yWindow = window.pageYOffset || 0;
    var yDoc = doc ? doc.scrollTop : 0;
    var yWrap = wrapper ? wrapper.scrollTop : 0;
    return Math.max(yWindow, yDoc, yWrap || 0);
  }

  /* Header : uniquement fond opaque au scroll (pas de hide/show) */
  function initHeaderGlass() {
    if (window.__lisseaHeaderGlassBound) return;
    window.__lisseaHeaderGlassBound = true;

    var ticking = false;

    function update() {
      document.body.classList.toggle('lissea-header-scrolled', getScrollY() > 80);
      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });

    var wrapper = document.querySelector('.page-wrapper');
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });

    window.addEventListener('resize', onScroll, { passive: true });
    update();
  }

  function boot() {
    enhanceSections();
    initHero();
    initScrollProgressReveals();
    initHeaderGlass();

    if (failsafeTimer) clearTimeout(failsafeTimer);
    failsafeTimer = setTimeout(function () {
      /* Seulement les éléments encore à 0 (hors écran bas) restent ;
         ceux déjà partiellement visibles sont laissés au scroll. */
      document.querySelectorAll('.lissea-reveal').forEach(function (el) {
        var p = parseFloat(el.style.getPropertyValue('--lissea-progress') || '0');
        if (p < 0.05 && el.getBoundingClientRect().top < window.innerHeight * 0.9) {
          el.style.setProperty('--lissea-progress', '1');
          el.classList.add('is-inview');
        }
      });
      document.querySelectorAll('.lissea-hero:not(.is-ready)').forEach(function (hero) {
        hero.classList.add('is-ready');
      });
    }, 2500);
  }

  if (window.__lisseaMotionBound) {
    boot();
    return;
  }
  window.__lisseaMotionBound = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) revealAll();
  });
})();
